import { Controller, UseFormReturn } from "react-hook-form";
import { TextAreaField } from "../DynamicFormTypes";
import { LassoTextField } from "../../LassoTextField";

type Props = {
    field: TextAreaField;
    form: UseFormReturn;
}

const TextAreaInput = ({ field, form }: Props) => {
    const { name, type, label, required = false, validationRules, defaultValue, placeholder = "", rows = 4 } = field;
    const { errors } = form.formState;

    return (
        <Controller
            control={form.control}
            name={name}
            rules={validationRules}
            defaultValue={defaultValue}
            render={({ field }) =>
                <LassoTextField
                    type={type}
                    label={label}
                    placeholder={placeholder}
                    fullWidth
                    required={required}
                    error={name in errors}
                    helperText={errors?.[name]?.message as string || ""}
                    multiline
                    rows={rows}
                    {...field}
                />}
        />
    );
}

export default TextAreaInput;